import PropTypes from 'prop-types';
import { useMyAccountLinks } from '@app/components/pages/account/hooks';
import { useRouterDomNavigation } from '@app/hooks';
import { CatIconStarFilled } from '@blocks-react/components/Icons/StarFilled';
import { useSelector } from 'react-redux';
import styles from '../../../savedList.module.scss';

const NameCell = ({ item }) => {
  const isCSR = useSelector(s => s.common?.isCatCSR);
  const { createdBy, orderId, name, favorite } = item;
  const { dynamicLinks } = useMyAccountLinks();
  const { anchorNavigate } = useRouterDomNavigation();
  const url = dynamicLinks.SAVED_LIST_DETAIL.getUrl({
    createdBy,
    name,
    orderId
  });
  return (
    <div className="d-flex justify-content-between align-items-center ">
      <a
        className={`text-decoration-none pe-2 ${styles['saved-list-table__name-cell']}`}
        href={url}
        onClick={!isCSR && anchorNavigate}
        data-cs-mask
      >
        {name}
      </a>
      {favorite && <CatIconStarFilled color="knockout-brand" />}
    </div>
  );
};

export default NameCell;

NameCell.propTypes = {
  item: PropTypes.shape({
    createdBy: PropTypes.string,
    lastUpdate: PropTypes.shape({
      unformattedDate: PropTypes.string,
      formattedDate: PropTypes.string
    }),
    name: PropTypes.string,
    orderId: PropTypes.string,
    quantity: PropTypes.number,
    reactKey: PropTypes.string,
    status: PropTypes.string,
    type: PropTypes.string,
    updated: PropTypes.number,
    updatedDisplayValue: PropTypes.string,
    favorite: PropTypes.bool
  })
};
